import styled from 'styled-components';
import { THideDayColumns } from '../../../types/reporting-history-types';
import {
  ExpanderContainer,
  FlexRow,
  Flexer,
  ReportingHistoryDataRow,
  ReportingHistoryItemDateLabel,
} from '../styles';

const PeriodHeaderContainer = styled(FlexRow)`
  padding: 10px;
`;

const FillerSpace = styled(ExpanderContainer)`
  cursor: default;
`;

type TPeriodHeaderProps = THideDayColumns & {
  label: string;
};

export function PeriodHeader(props: TPeriodHeaderProps) {
  return (
    <PeriodHeaderContainer>
      <ReportingHistoryDataRow>
        <Flexer className="reportingHistoryDataDateCell" size="lg" minWidth="140px">
          <ReportingHistoryItemDateLabel>
            {props.label}
          </ReportingHistoryItemDateLabel>
        </Flexer>

        {!props.hideDayColumns && (
          <Flexer className="reportingHistoryDataColumnHeaderCell" size="sm" justifyContent="center">
            Days Available
          </Flexer>
        )}

        {!props.hideDayColumns && (
        <Flexer className="reportingHistoryDataColumnHeaderCell" size="sm" justifyContent="center">
          Days Occupied
        </Flexer>
        )}

        <Flexer className="reportingHistoryDataColumnHeaderCell" size="md" justifyContent="center">
          Total Taxable Receipts
        </Flexer>

        <Flexer className="reportingHistoryDataColumnHeaderCell" size="md" justifyContent="center">
          Payment
        </Flexer>

        <Flexer className="reportingHistoryDataColumnHeaderCell" size="md" justifyContent="center">
          Paid by
        </Flexer>
      </ReportingHistoryDataRow>

      {/* This is meant to just take up space, so that the "columns" match up. */}
      <FillerSpace />
    </PeriodHeaderContainer>
  );
}
